export default __webpack_public_path__ + "static/header-subheader-anatomy-dark-b8bbc83f5be6f4f083ee5e3fc14aac80.png";